export default {
  recipeFinished: 'Das Rezept läuft nicht mehr. Ihre Änderungen können nicht gespeichert werden.',
  loadStarted: 'Während Ihrer Bearbeitung wurde eine Charge gestartet. Die Ofensollwerte können nur geändert werden, solange keine Charge läuft.',
  otherRecipeRunning: 'Inzwischen läuft eine andere Charge oder ein anderes Rezept. Ihre Änderungen können nicht gespeichert werden.',
  passedStepNotSaved: 'Änderungen an {step} werden nicht gespeichert, da der Schritt bereits abgeschlossen ist.',
};
